<template>
  <div class="form-widget-location form-item" @click="handleClick">
    <div class="form-item-content">
      <x-proxy-form-item
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="disabled"
      >
        <template v-if="renderSence === 'edit'">
          <span v-if="!formValue && !widget.readOnly" class="cube-input-field cube-input-field--placeholder">{{ '点击定位当前位置' }}</span>
          <span v-else class="location-span">{{ formValue && formValue.address }}</span>
        </template>
        
        <span v-if="renderSence === 'read'">{{ (formValue && formValue.address) || '-' }}</span>
      </x-proxy-form-item>
      <div v-if="renderSence === 'edit' && !widget.readOnly" class="form-item-suffix" :class="{ 'full-height': (validateInfo.validate !== 'error') }">
        <x-svg-icon v-if="!formValue" name="x-lib-location"></x-svg-icon>
        <x-svg-icon v-else name="x-lib-clear" @click.native="handleClear"></x-svg-icon>
      </div>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'

export default {
  name: 'FormWidgetLocation',
  mixins: [FormWidgetConfigMixin],
  inject: ['$compRouter'],
  computed: {
    disabled() {
      return this.widget.readOnly
    }
  },
  methods: {
    handleClear(e) {
      e.preventDefault()
      e.stopPropagation()
      this.formValue = null
    },
    handleClick() {
      if (!this.widget.readOnly) {
        this.$compRouter.push(this.$options.name, {
          key: this.propKey,
          widgetConfig: this.widget,
          value: this.formValue
        })
      }
    }
  }
}
</script>

<style lang="scss">
.form-widget-location {
  position: relative;
  .location-span {
    display: block;
    margin-right: 1rem;
  }
  .form-item-suffix {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 3.43rem;
    justify-content: center;
    width: 3.43rem;
    height: calc(100% - 1.71rem);
    font-size: 0;
    &.full-height {
      height: 100%;
    }
    .x-svg-icon {
      color: #B2B2B2;
    }
  }
}
</style>